import { vars } from '@/style/theme.css'
import { motion } from 'framer-motion'

export function AnimatedLine({
  x1,
  y1,
  x2,
  y2,
  color = vars.color.primary[500],
  strokeWidth = 2,
  dashArray,
}: {
  x1: number
  y1: number
  x2: number
  y2: number
  color?: string
  strokeWidth?: number
  dashArray?: string
}) {
  const d = `M ${x1},${y1} L ${x2},${y2}`

  return (
    <motion.path
      d={d}
      stroke={color}
      strokeWidth={strokeWidth}
      fill="transparent"
      strokeDasharray={dashArray}
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 0.3, ease: 'linear' }}
    />
  )
}